export const COLLAPSE_ANIMATION_MS = 300
